import React, { useEffect, createElement } from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { HERO_BANNER_URL } from './data/constants';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { BoatFinderQuiz } from './components/BoatFinderQuiz';
import { FleetCatalog } from './components/FleetCatalog';
import { PremiumFleet } from './components/PremiumFleet';
import { JetSkiSection } from './components/JetSkiSection';
import { LicenseSection } from './components/LicenseSection';
import { HowItWorks } from './components/HowItWorks';
import { WhyKevinBoats } from './components/WhyKevinBoats';
import { Gallery } from './components/Gallery';
import { ContactSection } from './components/ContactSection';
import { Reviews } from './components/Reviews';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
const MainApp = () => {
  useEffect(() => {
    document.title = 'Kevin Boats | Alquiler de Barcos en Torrevieja sin Licencia';
    // Open Graph meta tags for link previews (WhatsApp, Facebook, etc.)
    const upsertMeta = (property: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    const ogTags: Record<string, string> = {
      'og:title': 'Kevin Boats - Alquiler de Barcos en Torrevieja',
      'og:description': 'Alquila tu barco en Torrevieja desde 125€. 13 embarcaciones disponibles. Con o sin licencia. Reserva rápida por WhatsApp.',
      'og:image': HERO_BANNER_URL,
      'og:url': window.location.origin,
      'og:type': 'website',
      'og:image:width': '1200',
      'og:image:height': '630'
    };
    Object.entries(ogTags).forEach(([property, content]) => upsertMeta(property, content));
  }, []);
  return <div className="min-h-screen bg-white font-sans text-navy selection:bg-turquoise selection:text-navy" data-id="element-0" data-mp="3udknlyaisybg">
      <Header data-id="element-1" data-mp="d3mlpfjtr3m9" />
      <main data-id="element-2" data-mp="d3cwvvain2i5">
        <Hero data-id="element-3" data-mp="d3wch5cp1et0" />
        <TrustBar data-id="element-4" data-mp="d2l6cyvrzuyq" />
        <BoatFinderQuiz data-id="element-5" data-mp="85uihpdqbv2r" />
        <FleetCatalog data-id="element-6" data-mp="85bc95xfyv4k" />
        <PremiumFleet data-id="element-7" data-mp="864atjm8yebm" />
        <JetSkiSection data-id="element-8" data-mp="83i1befspoqr" />
        <LicenseSection data-id="element-9" data-mp="3gl4sdjnv24l3" />
        <HowItWorks data-id="element-10" data-mp="3gmfw5jhb3cc7" />
        <WhyKevinBoats data-id="element-11" data-mp="3glwbvw46obv0" />
        <Gallery data-id="element-12" data-mp="3gja2rs1n9oao" />
        <ContactSection data-id="element-13" data-mp="3bmbazg5gdtfn" />
        <Reviews data-id="element-14" data-mp="3bn30c98giuxh" />
      </main>
      <Footer data-id="element-15" data-mp="3bnurn7v0u6hy" />
      <FloatingWhatsApp data-id="element-16" data-mp="3bk71miosc27z" />
    </div>;
};
export function App() {
  return <LanguageProvider data-id="element-17" data-mp="3qcr0v88tdpk5">
      <MainApp data-id="element-18" data-mp="3qdajkr6aghz8" />
    </LanguageProvider>;
}